import React, { useEffect, useCallback, useState} from 'react';
import {BANG} from 'messaging/message-types.js';
import {connect} from 'react-redux';
import './custom.scss';
const ZDPad = ({dpad}) => { 
    const send = useCallback((e, cmd) => {
        e.stopPropagation();
        dpad.sendMessage(cmd, BANG);
    }, [dpad]);
    return (
        <div className="dpad">

          <div className="arrows-row">
            <div
              onClick={e => send(e, "up")}
              className="g-btn">
              <div className="arrow-up"/>
            </div>
          </div>
          <div className="arrows-row">
            <div
              onClick={e => send(e, "left")}
              className="g-btn">
              <div className="arrow-left"/>
            </div>
            <div
              onClick={e => send(e, "right")}
              className="g-btn">
              <div className="arrow-right"/>
            </div>
          </div>
          <div className="arrows-row">
            <div
              onClick={e => send(e, "down", )}
              className="g-btn">
              <div className="arrow-down"/>
            </div>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZDPad);
